import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PrecificacaoUF } from 'src/app/models/precificacao-uf';

@Component({
  selector: 'app-cadastrar-precificacao-ufmodal',
  templateUrl: './cadastrar-precificacao-ufmodal.component.html',
  styleUrls: ['./cadastrar-precificacao-ufmodal.component.scss']
})
export class CadastrarPrecificacaoUFModalComponent implements OnInit {
  item: PrecificacaoUF;
  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

  tipoDa = [{id: 0, descricao: 'Desconto'}, {id:1, descricao: 'Acréscimo'}];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CadastrarPrecificacaoUFModalComponent>
  ) {
    this.item = this.data.item;
    console.log('item: ', this.item);
  }

  ngOnInit(): void {
  }

  salvar() {
    this.dialogRef.close(this.item);
  }

  fechar() {
    this.dialogRef.close();
  }

}
